export default "__VITE_ASSET__D$pvUBp5__"